import { createTheme } from 'baseui';
import deepMerge from 'baseui/utils/deep-merge';
import '../../components/icon/icons/account.js';
import '../../components/icon/icons/action.js';
import '../../components/icon/icons/ad.js';
import '../../components/icon/icons/add-car.js';
import { IconAdd } from '../../components/icon/icons/add.js';
import '../../components/icon/icons/additional-cost.js';
import '../../components/icon/icons/advertiser-type.js';
import '../../components/icon/icons/after-sales-service.js';
import '../../components/icon/icons/air-conditioning-01.js';
import '../../components/icon/icons/air-conditioning-02.js';
import '../../components/icon/icons/air-conditioning-03.js';
import '../../components/icon/icons/amenities.js';
import '../../components/icon/icons/announcements-on-site.js';
import '../../components/icon/icons/apple-car-android-auto.js';
import '../../components/icon/icons/apple.js';
import '../../components/icon/icons/archive.js';
import '../../components/icon/icons/arrow-down.js';
import '../../components/icon/icons/arrow-left.js';
import '../../components/icon/icons/arrow-right.js';
import '../../components/icon/icons/arrow-up.js';
import '../../components/icon/icons/at.js';
import '../../components/icon/icons/attachment.js';
import '../../components/icon/icons/auto-repost-off.js';
import '../../components/icon/icons/auto-repost-on.js';
import '../../components/icon/icons/baby-pacifier.js';
import '../../components/icon/icons/balcony-garden-terrace.js';
import '../../components/icon/icons/bank.js';
import '../../components/icon/icons/bathroom.js';
import '../../components/icon/icons/bedroom.js';
import '../../components/icon/icons/benefit-center.js';
import '../../components/icon/icons/block-user.js';
import '../../components/icon/icons/blueprint.js';
import '../../components/icon/icons/boat-propulsion.js';
import '../../components/icon/icons/boat.js';
import '../../components/icon/icons/body-type.js';
import '../../components/icon/icons/bold-text.js';
import '../../components/icon/icons/bookmark-filled.js';
import '../../components/icon/icons/bookmark.js';
import '../../components/icon/icons/brand.js';
import '../../components/icon/icons/bullet-list.js';
import '../../components/icon/icons/cabrio.js';
import '../../components/icon/icons/calculator.js';
import '../../components/icon/icons/calendar.js';
import '../../components/icon/icons/call.js';
import '../../components/icon/icons/camera.js';
import '../../components/icon/icons/car-1.js';
import '../../components/icon/icons/car-2.js';
import '../../components/icon/icons/car-accident.js';
import '../../components/icon/icons/car-basic.js';
import '../../components/icon/icons/car-financing.js';
import '../../components/icon/icons/car-history.js';
import '../../components/icon/icons/car-washing.js';
import '../../components/icon/icons/car.js';
import '../../components/icon/icons/caravan.js';
import '../../components/icon/icons/card.js';
import '../../components/icon/icons/chat.js';
import '../../components/icon/icons/check-filled.js';
import '../../components/icon/icons/check-up.js';
import '../../components/icon/icons/check.js';
import { IconChevronDown } from '../../components/icon/icons/chevron-down.js';
import { IconChevronLeft } from '../../components/icon/icons/chevron-left.js';
import { IconChevronRight } from '../../components/icon/icons/chevron-right.js';
import { IconChevronUp } from '../../components/icon/icons/chevron-up.js';
import '../../components/icon/icons/chopper.js';
import '../../components/icon/icons/city-car.js';
import '../../components/icon/icons/clear-content.js';
import '../../components/icon/icons/clear.js';
import { IconClose } from '../../components/icon/icons/close.js';
import '../../components/icon/icons/coin-money.js';
import '../../components/icon/icons/color.js';
import '../../components/icon/icons/comfort-access.js';
import '../../components/icon/icons/complaint-book.js';
import '../../components/icon/icons/condition.js';
import '../../components/icon/icons/construction-material.js';
import '../../components/icon/icons/construction-start.js';
import '../../components/icon/icons/contact-views.js';
import '../../components/icon/icons/copy.js';
import '../../components/icon/icons/coupe.js';
import '../../components/icon/icons/credit-card.js';
import '../../components/icon/icons/cross.js';
import '../../components/icon/icons/cruiser.js';
import '../../components/icon/icons/cube.js';
import '../../components/icon/icons/cv.js';
import '../../components/icon/icons/delivery.js';
import '../../components/icon/icons/document.js';
import '../../components/icon/icons/door.js';
import '../../components/icon/icons/double-chevron-down.js';
import '../../components/icon/icons/double-chevron-up.js';
import '../../components/icon/icons/double-tick.js';
import '../../components/icon/icons/download.js';
import '../../components/icon/icons/drivetrain.js';
import '../../components/icon/icons/early-access.js';
import '../../components/icon/icons/edit.js';
import '../../components/icon/icons/education.js';
import '../../components/icon/icons/email-at.js';
import '../../components/icon/icons/email.js';
import '../../components/icon/icons/enduro.js';
import '../../components/icon/icons/engine.js';
import '../../components/icon/icons/error.js';
import '../../components/icon/icons/estate.js';
import '../../components/icon/icons/external-link.js';
import { IconEyeHidden } from '../../components/icon/icons/eye-hidden.js';
import '../../components/icon/icons/eye-not.js';
import { IconEye } from '../../components/icon/icons/eye.js';
import '../../components/icon/icons/facebook.js';
import '../../components/icon/icons/fast-repair.js';
import '../../components/icon/icons/fence.js';
import '../../components/icon/icons/file-attachment.js';
import { IconFilter } from '../../components/icon/icons/filter.js';
import '../../components/icon/icons/finish-condition.js';
import '../../components/icon/icons/flag.js';
import '../../components/icon/icons/floor.js';
import '../../components/icon/icons/form-of-the-property.js';
import '../../components/icon/icons/fuel.js';
import '../../components/icon/icons/fullscreen-view.js';
import '../../components/icon/icons/glass-roof.js';
import '../../components/icon/icons/globe.js';
import '../../components/icon/icons/goods.js';
import '../../components/icon/icons/grid-view.js';
import '../../components/icon/icons/grid.js';
import '../../components/icon/icons/hatchback.js';
import '../../components/icon/icons/headlights.js';
import '../../components/icon/icons/heart-default.js';
import '../../components/icon/icons/heart-filled.js';
import '../../components/icon/icons/heart-on-hand.js';
import '../../components/icon/icons/heart-search.js';
import '../../components/icon/icons/heating.js';
import '../../components/icon/icons/height-of-rooms.js';
import '../../components/icon/icons/helpdesk.js';
import '../../components/icon/icons/home-default.js';
import '../../components/icon/icons/home-filled.js';
import '../../components/icon/icons/home.js';
import '../../components/icon/icons/hud.js';
import '../../components/icon/icons/id-card.js';
import { IconInfo } from '../../components/icon/icons/info.js';
import '../../components/icon/icons/insert-link.js';
import '../../components/icon/icons/instagram.js';
import '../../components/icon/icons/interior.js';
import '../../components/icon/icons/investment-status.js';
import '../../components/icon/icons/italic-text.js';
import '../../components/icon/icons/jobs.js';
import '../../components/icon/icons/kiosk.js';
import '../../components/icon/icons/land-area.js';
import '../../components/icon/icons/license-plate.js';
import '../../components/icon/icons/lighting.js';
import '../../components/icon/icons/like.js';
import '../../components/icon/icons/list-item-default.js';
import '../../components/icon/icons/list-item-filled.js';
import '../../components/icon/icons/list-view.js';
import '../../components/icon/icons/list.js';
import '../../components/icon/icons/location.js';
import '../../components/icon/icons/lock.js';
import '../../components/icon/icons/login-to-continue.js';
import '../../components/icon/icons/logout.js';
import '../../components/icon/icons/lorry.js';
import '../../components/icon/icons/lory.js';
import '../../components/icon/icons/machinery.js';
import '../../components/icon/icons/make-model.js';
import '../../components/icon/icons/map-view.js';
import '../../components/icon/icons/market.js';
import '../../components/icon/icons/material.js';
import '../../components/icon/icons/meal-1.js';
import '../../components/icon/icons/meal-2.js';
import { IconMenu } from '../../components/icon/icons/menu.js';
import '../../components/icon/icons/message-default.js';
import '../../components/icon/icons/message-filled.js';
import '../../components/icon/icons/message.js';
import '../../components/icon/icons/milage.js';
import '../../components/icon/icons/millage.js';
import { IconMinus } from '../../components/icon/icons/minus.js';
import '../../components/icon/icons/moped.js';
import '../../components/icon/icons/more-info.js';
import '../../components/icon/icons/more.js';
import '../../components/icon/icons/motociclos-nacionais.js';
import '../../components/icon/icons/motorbike.js';
import '../../components/icon/icons/motorcycle-125.js';
import '../../components/icon/icons/mpv.js';
import '../../components/icon/icons/n-people-in-the-room.js';
import '../../components/icon/icons/n-rooms.js';
import '../../components/icon/icons/naked.js';
import '../../components/icon/icons/no-camera.js';
import '../../components/icon/icons/non-smoker.js';
import '../../components/icon/icons/notification-default.js';
import '../../components/icon/icons/notification-filled.js';
import '../../components/icon/icons/notification.js';
import '../../components/icon/icons/one-owner.js';
import '../../components/icon/icons/open-photo-gallery.js';
import '../../components/icon/icons/package-selected.js';
import '../../components/icon/icons/parking-assistance.js';
import '../../components/icon/icons/parking-space.js';
import '../../components/icon/icons/parts-1.js';
import '../../components/icon/icons/parts-2.js';
import '../../components/icon/icons/parts-3.js';
import '../../components/icon/icons/parts-4.js';
import '../../components/icon/icons/parts-cog.js';
import '../../components/icon/icons/parts-disc-brake.js';
import '../../components/icon/icons/parts-steering-wheel.js';
import '../../components/icon/icons/parts-timing-belt.js';
import '../../components/icon/icons/party-popper.js';
import '../../components/icon/icons/passport.js';
import '../../components/icon/icons/pause.js';
import '../../components/icon/icons/people.js';
import '../../components/icon/icons/percent.js';
import '../../components/icon/icons/picture.js';
import '../../components/icon/icons/ping-pong.js';
import '../../components/icon/icons/play.js';
import '../../components/icon/icons/plot-type.js';
import '../../components/icon/icons/plutus.js';
import '../../components/icon/icons/postpaid.js';
import '../../components/icon/icons/power-on.js';
import '../../components/icon/icons/power.js';
import '../../components/icon/icons/premium.js';
import '../../components/icon/icons/price.js';
import '../../components/icon/icons/print.js';
import '../../components/icon/icons/private-seller.js';
import '../../components/icon/icons/professional-seller.js';
import '../../components/icon/icons/proforma.js';
import '../../components/icon/icons/promote.js';
import '../../components/icon/icons/properties-in-investment.js';
import '../../components/icon/icons/purpose.js';
import '../../components/icon/icons/qr-code.js';
import '../../components/icon/icons/quad.js';
import '../../components/icon/icons/quality-mark-filled.js';
import '../../components/icon/icons/quality-mark.js';
import '../../components/icon/icons/question-mark.js';
import '../../components/icon/icons/read-messages.js';
import '../../components/icon/icons/real-estate-agency.js';
import '../../components/icon/icons/real-estate-agent.js';
import '../../components/icon/icons/real-estate-consultant.js';
import '../../components/icon/icons/real-estate-developer.js';
import '../../components/icon/icons/real-estate-investors.js';
import '../../components/icon/icons/real-estate-managers.js';
import '../../components/icon/icons/real-estate-private-seller.js';
import '../../components/icon/icons/refresh.js';
import '../../components/icon/icons/remote-support.js';
import '../../components/icon/icons/remote-work.js';
import '../../components/icon/icons/rent.js';
import '../../components/icon/icons/rental.js';
import '../../components/icon/icons/repair.js';
import '../../components/icon/icons/reset-size.js';
import '../../components/icon/icons/resize-to-width.js';
import '../../components/icon/icons/resize.js';
import '../../components/icon/icons/restore.js';
import '../../components/icon/icons/road-mileage.js';
import '../../components/icon/icons/scooter-above-125.js';
import '../../components/icon/icons/scooter.js';
import '../../components/icon/icons/screen-desktop.js';
import '../../components/icon/icons/screen-mobile.js';
import '../../components/icon/icons/scroller-1.js';
import '../../components/icon/icons/scroller-2.js';
import '../../components/icon/icons/search-history.js';
import { IconSearch } from '../../components/icon/icons/search.js';
import '../../components/icon/icons/seat.js';
import '../../components/icon/icons/security.js';
import '../../components/icon/icons/sedan.js';
import '../../components/icon/icons/send.js';
import '../../components/icon/icons/share.js';
import '../../components/icon/icons/sheet-metal-repairs.js';
import '../../components/icon/icons/size-1.js';
import '../../components/icon/icons/size.js';
import '../../components/icon/icons/small-city-car.js';
import '../../components/icon/icons/sms-finance.js';
import '../../components/icon/icons/sms.js';
import '../../components/icon/icons/social-facebook.js';
import '../../components/icon/icons/social-instagram.js';
import '../../components/icon/icons/social-linkedin.js';
import '../../components/icon/icons/social-tiktok.js';
import '../../components/icon/icons/social-twitter.js';
import '../../components/icon/icons/social-whatsapp.js';
import '../../components/icon/icons/social-x-aka-twitter.js';
import '../../components/icon/icons/social-youtube.js';
import '../../components/icon/icons/sort-by.js';
import '../../components/icon/icons/sound-system.js';
import '../../components/icon/icons/sport-tourism.js';
import '../../components/icon/icons/sport.js';
import '../../components/icon/icons/stack-view.js';
import '../../components/icon/icons/stack.js';
import '../../components/icon/icons/star-default.js';
import '../../components/icon/icons/star-filled.js';
import '../../components/icon/icons/star-half.js';
import '../../components/icon/icons/star.js';
import '../../components/icon/icons/stats.js';
import '../../components/icon/icons/stethoscope.js';
import '../../components/icon/icons/style.js';
import '../../components/icon/icons/styling.js';
import '../../components/icon/icons/suitcase.js';
import '../../components/icon/icons/sun-and-sea.js';
import '../../components/icon/icons/surface.js';
import '../../components/icon/icons/suspension.js';
import '../../components/icon/icons/suv-crossover-tt.js';
import '../../components/icon/icons/target.js';
import '../../components/icon/icons/technical-review.js';
import '../../components/icon/icons/telephone.js';
import '../../components/icon/icons/tempomat.js';
import '../../components/icon/icons/test-drive.js';
import '../../components/icon/icons/thumbs-down.js';
import '../../components/icon/icons/thumbs-up.js';
import '../../components/icon/icons/tick-double.js';
import '../../components/icon/icons/tick-one.js';
import { IconTick } from '../../components/icon/icons/tick.js';
import '../../components/icon/icons/time.js';
import '../../components/icon/icons/tire-storage.js';
import '../../components/icon/icons/tire.js';
import '../../components/icon/icons/token.js';
import '../../components/icon/icons/tooth.js';
import '../../components/icon/icons/touring.js';
import '../../components/icon/icons/towing.js';
import '../../components/icon/icons/tractor.js';
import '../../components/icon/icons/trailler.js';
import '../../components/icon/icons/transfer.js';
import '../../components/icon/icons/translation-bubble.js';
import '../../components/icon/icons/transmission.js';
import '../../components/icon/icons/trash.js';
import '../../components/icon/icons/travel-assistance.js';
import '../../components/icon/icons/tricycle.js';
import '../../components/icon/icons/truck.js';
import '../../components/icon/icons/trunk-access.js';
import '../../components/icon/icons/twitter.js';
import '../../components/icon/icons/type-of-building.js';
import '../../components/icon/icons/unarchive.js';
import '../../components/icon/icons/unordered-list.js';
import '../../components/icon/icons/unread-messages.js';
import { IconUpload } from '../../components/icon/icons/upload.js';
import '../../components/icon/icons/user-default.js';
import '../../components/icon/icons/user-filled.js';
import '../../components/icon/icons/utilitarian.js';
import '../../components/icon/icons/video.js';
import '../../components/icon/icons/virtual-cockpit.js';
import '../../components/icon/icons/voice.js';
import '../../components/icon/icons/wallet.js';
import '../../components/icon/icons/warning.js';
import '../../components/icon/icons/weight.js';
import '../../components/icon/icons/year-of-construction.js';
import '../../components/icon/icons/youtube.js';
import { olxTheme } from './theme.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const primaries = {
  primary: olxTheme.palettes.gray.charcoal,
  primary50: olxTheme.palettes.gray.white,
  primary100: olxTheme.palettes.gray.white,
  primary200: olxTheme.palettes.gray.gray2,
  primary300: olxTheme.palettes.gray.gray3,
  primary400: olxTheme.palettes.gray.gray4,
  primary500: olxTheme.palettes.gray.gray5,
  primary600: olxTheme.palettes.gray.gray6,
  primary700: olxTheme.palettes.gray.charcoal
};
const accents = {
  accent: olxTheme.palettes.teal.primary,
  accent50: olxTheme.palettes.teal.bg_light,
  accent100: olxTheme.palettes.teal.light,
  accent200: olxTheme.palettes.teal.tint_light,
  accent300: olxTheme.palettes.teal.tint_dark,
  accent400: olxTheme.palettes.teal.primary,
  accent500: olxTheme.palettes.teal.dark,
  accent600: olxTheme.palettes.teal.bg_dark,
  accent700: olxTheme.palettes.teal.bg_dark
};
const negatives = {
  negative: olxTheme.palettes.red.primary,
  negative50: olxTheme.palettes.red.bg_light,
  negative100: olxTheme.palettes.red.light,
  negative200: olxTheme.palettes.red.tint_light,
  negative300: olxTheme.palettes.red.tint_dark,
  negative400: olxTheme.palettes.red.primary,
  negative500: olxTheme.palettes.red.dark,
  negative600: olxTheme.palettes.red.bg_dark,
  negative700: olxTheme.palettes.red.bg_dark
};
const warnings = {
  warning: olxTheme.palettes.yellow.primary,
  warning50: olxTheme.palettes.yellow.bg_light,
  warning100: olxTheme.palettes.yellow.light,
  warning200: olxTheme.palettes.yellow.tint_light,
  warning300: olxTheme.palettes.yellow.tint_dark,
  warning400: olxTheme.palettes.yellow.primary,
  warning500: olxTheme.palettes.yellow.dark,
  warning600: olxTheme.palettes.yellow.bg_dark,
  warning700: olxTheme.palettes.yellow.bg_dark
};
const positives = {
  positive: olxTheme.palettes.teal.primary,
  positive50: olxTheme.palettes.teal.bg_light,
  positive100: olxTheme.palettes.teal.light,
  positive200: olxTheme.palettes.teal.tint_light,
  positive300: olxTheme.palettes.teal.tint_dark,
  positive400: olxTheme.palettes.teal.primary,
  positive500: olxTheme.palettes.teal.dark,
  positive600: olxTheme.palettes.teal.bg_dark,
  positive700: olxTheme.palettes.teal.bg_dark
};
const rawBaseTheme = createTheme(__spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, primaries), accents), negatives), warnings), positives), {
  primaryA: olxTheme.palettes.gray.charcoal,
  primaryB: olxTheme.palettes.gray.white,
  primaryFontFamily: "Geomanist, Arial, sans-serif"
}), {
  typography: {
    HeadingXXLarge: olxTheme.typography.h1,
    HeadingXLarge: olxTheme.typography.h2,
    HeadingLarge: olxTheme.typography.h3,
    HeadingMedium: olxTheme.typography.h4,
    HeadingSmall: olxTheme.typography.h4,
    HeadingXSmall: olxTheme.typography.h4,
    ParagraphLarge: olxTheme.typography.p1,
    ParagraphMedium: olxTheme.typography.p2,
    ParagraphSmall: olxTheme.typography.p3,
    ParagraphXSmall: olxTheme.typography.p4,
    LabelLarge: {
      fontSize: olxTheme.fontSizes[16],
      fontWeight: olxTheme.fontWeights.regular,
      lineHeight: olxTheme.lineHeights[20]
    },
    LabelMedium: {
      fontSize: olxTheme.fontSizes[14],
      fontWeight: olxTheme.fontWeights.regular,
      lineHeight: olxTheme.lineHeights[18]
    },
    LabelSmall: {
      fontSize: olxTheme.fontSizes[12],
      fontWeight: olxTheme.fontWeights.regular,
      lineHeight: olxTheme.lineHeights[16]
    },
    LabelXSmall: {
      fontSize: olxTheme.fontSizes[11],
      fontWeight: olxTheme.fontWeights.regular,
      lineHeight: olxTheme.lineHeights[14]
    }
  },
  colors: {
    buttonPrimaryFill: olxTheme.palettes.gray.charcoal,
    buttonPrimaryText: olxTheme.palettes.gray.white,
    buttonPrimaryHover: olxTheme.palettes.gray.white,
    buttonPrimaryActive: olxTheme.palettes.gray.gray5,
    buttonSecondaryFill: olxTheme.palettes.gray.white,
    buttonSecondaryText: olxTheme.palettes.gray.charcoal,
    buttonSecondaryHover: olxTheme.palettes.gray.white,
    buttonSecondaryActive: olxTheme.palettes.gray.gray5,
    buttonTertiaryFill: olxTheme.palettes.transparent,
    buttonTertiaryText: olxTheme.palettes.gray.charcoal,
    buttonTertiaryHover: olxTheme.palettes.transparent,
    buttonTertiaryActive: olxTheme.palettes.transparent,
    buttonTertiarySelectedFill: olxTheme.palettes.transparent,
    buttonTertiarySelectedText: olxTheme.palettes.gray.charcoal,
    buttonDisabledFill: olxTheme.palettes.gray.gray4,
    buttonDisabledText: olxTheme.palettes.gray.gray5,
    inputBorder: olxTheme.palettes.gray.gray3,
    inputFill: olxTheme.palettes.gray.gray3,
    inputFillActive: olxTheme.palettes.gray.gray3,
    inputPlaceholder: olxTheme.palettes.gray.gray6,
    inputFillError: olxTheme.palettes.gray.gray3,
    inputBorderError: olxTheme.palettes.red.primary,
    inputBorderPositive: olxTheme.palettes.gray.gray3,
    inputFillPositive: olxTheme.palettes.gray.gray3,
    inputTextDisabled: olxTheme.palettes.gray.gray5,
    inputPlaceholderDisabled: olxTheme.palettes.gray.gray5,
    tagPrimaryFontDisabled: olxTheme.palettes.gray.gray5,
    tagPrimarySolidFont: olxTheme.palettes.gray.charcoal,
    tagPrimarySolidBackground: olxTheme.palettes.gray.gray4,
    tagPrimaryOutlinedBackground: olxTheme.palettes.gray.white,
    tagPrimaryOutlinedFont: olxTheme.palettes.gray.charcoal,
    tickFill: olxTheme.palettes.gray.white,
    tickFillHover: olxTheme.palettes.gray.white,
    tickFillActive: olxTheme.palettes.gray.white,
    tickFillSelected: olxTheme.palettes.gray.charcoal,
    tickFillSelectedHover: olxTheme.palettes.gray.charcoal,
    tickFillSelectedHoverActive: olxTheme.palettes.gray.charcoal,
    tickFillError: olxTheme.palettes.gray.white,
    tickFillErrorHover: olxTheme.palettes.gray.white,
    tickFillErrorHoverActive: olxTheme.palettes.gray.white,
    tickFillErrorSelected: olxTheme.palettes.red.primary,
    tickFillErrorSelectedHover: olxTheme.palettes.red.primary,
    tickFillErrorSelectedHoverActive: olxTheme.palettes.red.primary,
    tickFillDisabled: olxTheme.palettes.gray.gray5,
    tickBorder: olxTheme.palettes.gray.charcoal,
    tickBorderError: olxTheme.palettes.red.primary,
    tickMarkFill: olxTheme.palettes.gray.white,
    tickMarkFillError: olxTheme.palettes.gray.white,
    tickMarkFillDisabled: olxTheme.palettes.gray.white,
    comboboxListItemHover: olxTheme.palettes.gray.gray4,
    comboboxListItemFocus: olxTheme.palettes.gray.charcoal
  },
  borders: {
    buttonBorderRadius: olxTheme.radii[4],
    inputBorderRadius: olxTheme.radii[4]
  },
  breakpoints: {
    small: olxTheme.breakpoints.xs,
    medium: olxTheme.breakpoints.md,
    large: olxTheme.breakpoints.xl
  },
  mediaQuery: {
    small: olxTheme.mediaQuery.xs,
    medium: olxTheme.mediaQuery.md,
    large: olxTheme.mediaQuery.xl
  },
  icons: {
    Alert: IconInfo,
    // ArrowDown,
    // ArrowLeft,
    // ArrowRight,
    // ArrowUp,
    // Blank,
    CheckIndeterminate: IconMinus,
    Check: IconTick,
    ChevronDown: IconChevronDown,
    ChevronLeft: IconChevronLeft,
    ChevronRight: IconChevronRight,
    ChevronUp: IconChevronUp,
    DeleteAlt: IconClose,
    // Delete,
    Filter: IconFilter,
    // Grab,
    Hide: IconEyeHidden,
    Menu: IconMenu,
    // Overflow,
    Plus: IconAdd,
    Search: IconSearch,
    Show: IconEye,
    // Spinner,
    TriangleDown: IconChevronDown,
    TriangleLeft: IconChevronLeft,
    TriangleRight: IconChevronRight,
    TriangleUp: IconChevronUp,
    Upload: IconUpload
  }
});
const baseOlxTheme = deepMerge(rawBaseTheme, olxTheme);

export { baseOlxTheme };
